







import { Component, Vue } from 'vue-property-decorator';
import HealthInsuranceForm from './HealthInsuranceForm.vue';
import { MedTransGoConstants } from '@/util/constants';
import { ProfileRequest } from '@/types/request';
import { ObjectFactory } from '@/config/objectFactory';

@Component({
    components: {
        HealthInsuranceForm,
    },
    props: {
        request: Object,
    },
})
export default class HealthInsuranceInfo extends Vue {
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private mounted() {
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('homeHealthCare')) {
            const profileRequest = this.getProfileRequest();
            profileRequest.isStepHIValid = false;
            if (this.sessionInfo.scopes.includes('transporter') && !profileRequest.isStepADValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_DRIVER_INFO_NAME });
            } else if (!profileRequest.isStepQnValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
            }
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_TRANSPORTATION_QUESTIONNAIRE_NAME });
        }
    }

    private getProfileRequest(): ProfileRequest {
        return this.$props.request as ProfileRequest;
    }

}
